var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comment"},[_c('span',{staticClass:"author"},[_c('img',{staticClass:"supel",attrs:{"src":_vm.comment.author.avatar}}),_vm._v(" "+_vm._s(_vm.comment.author.username)+" ")]),_c('span',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.comment.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }